import services from './../../services/service'; // Service Class
import commons from './../../services/commons'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import ProductList from '../../components/product/ProductList.vue'
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 
import SearchBox from './../../components/templates/searchbox.vue'; 
import Settings from './../../components/tools/settings.vue';
let service = new services();
let set = new commons();

export default {
    data () {
        return {
            plan_user:{},
            plan_business:{},
            user:{},
            market:{},
            business:{},
            categories:{},
            subscriptions:{},
            business_service_categories:[],
            business_product_categories:[],
            business_category_type:0,
            plan1:{},
            plan2:{},
            plan3:{},
            selected_plan:{},
            selected_plan_product_service_item:{},
            upgradable_plans:{},
            upgrade_business:"",
            upgrade_subscription: 0,
            current_subscription_product_service_item: 0,
            set_upgrade_plans:false,
            place_order:false,
            //boarding_messages:[],
            data_boarding_message:"",
            set_up_with_existing_account: false,
            set_up_with_new_account:false,
            set_up_business:false,
            validate_user_name_error:false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name:"",
            payment_payer_email:"",
            payment_payer_phone:"",
            payment_service:"",
            payment_ref:"",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            action_loading:false,
            disable_btn:false,
            setup_error_message:"",
            newBusinessForm:false,
            product_service_items_select:"",
            set_upgrade_plan_process: false,
            //
            header_data:{},
            set_purchase_process: false,
            picked_plan:{},
            user_businesses:{},
            selected_business:{},
            referral_code:'',
            order_details:'',
            order_coupon:'',
            order_amount:0,
            order_amount_to_pay:0,
            set_checkout:false,
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
        'search-box': SearchBox,
        'c-settings':Settings,
    },
    computed: {
        
    },
    methods: {
        setCurrency(currency){
            return set.formatCurrency(currency);
        },

        setComponent(attr1,attr2){
            this.data_error_message = ""; //reset
            if(attr1 == 'setup-existing'){
                this.set_up_with_existing_account = true;
            }
            if(attr1 == 'not-setup-existing'){
                this.set_up_with_existing_account = false;
            }
            if(attr1 == 'show-new-business-form'){
                this.newBusinessForm = true;
            }
            if(attr1 == 'display-product_service_items'){
                //toggle display
                var x = document.getElementById("productServiceItems");
                if (x.style.display === "none") {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
            
        },
        reset(){
            this.set_upgrade_plan_process = false;
            this.set_purchase_process = false;
            this.data_error_message = "";
        },

        toggleDisplayFeatures(){
            var x = document.getElementById("seeFeatures");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        selectProductServiceItem(item){
            this.selected_plan_product_service_item = item;
            //setts-checks
            if(this.order_amount_to_pay > 0){
                this.setProcessPurchase();
            }
            //
            //toggle display
            var x = document.getElementById("productServiceItems");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },

        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = localStorage.getItem("sp_user");
                    self.loggedIn = true;
                    self.loading = false;
                    //check for upgrade request
                    if(self.$route.query.upgrade){
                        self.prepareUpgradePlans();
                    }
                }else {
                    // self.$router.push('login');
                }
            });
        },

        getAppUserAndBusinessesDetails(){
            if(this.user.user_id > 0){
                var payload = {
                    user: this.user.user_id,
                    user_purchase_plan_product: this.selected_plan.product_id,
                    user_purchase_plan: this.selected_plan_product_service_item.product_item_id,
                }
                this.checkUserDetailsForPurchase(payload,0);
            }
        },

        setPurchase(){
            //set view
            this.set_purchase_process = true;
            //get the route query
            let query_plan = this.$route.query.purchase; //the subscription product-service
            let query_plan_item = this.$route.query.item; //the actual subscription product-service item array index
           
            //set the matching plan
            let found = false;
            //loop through subscriptions
            this.subscriptions.forEach(function(element) {
                if(element.product_url_name == query_plan){
                    this.selected_plan = element;
                    if(query_plan_item != 'n'){ // 'n' is a default mark to show no product item assigned
                        if(element.product_items[query_plan_item]){ //check/confirm if array index exists recode later
                            this.selected_plan_product_service_item = element.product_items[query_plan_item];
                        }else{
                            this.selected_plan_product_service_item = element.product_items[0]; //assign ist in array
                        }
                    }else{
                       // this.selected_plan_product_service_item = element.product_items[0]; //still assign ist in array
                        for(let pt of element.product_items){
                            //assign featured plan
                            if(pt.product_item_service_tag == '1 year'){
                                this.selected_plan_product_service_item = pt;
                            }
                        }
                    }
                    
                    found = true;
                    //get app user and businesses details 
                    this.getAppUserAndBusinessesDetails();
                    //disable loading
                    this.loading = false;
                }
            }, this);
            
            //if noot found
            if(!found){
                this.setup_error_message = "Something went wrong with your selection, please pick another plan"
            }
             //disable loading
            this.loading = false;

        },

        prepareUpgradePlans(){
            this.loading = true;
            if(this.plan_business.business_id > 0){
                let navi = this.$router; 
                var payload = {
                    subscriber_module: 3, //business
                    subscriber_module_id: this.plan_business.business_id,
                    subscription_module: 3, //business
                    subscription_module_id: 'APP',
                }
                service.setAppSubscriptionUpgradeDetails(this, payload).then(function(data) {
                    this.upgradable_plans = data.body.data;
                    this.upgrade_subscription = data.body.data_subscription;
                    this.current_subscription_product_service_item = data.body.data_subscription_current_subscription;
                    this.upgrade_business = this.$route.query.upgrade;
                    //set payment details
                    this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                    this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                    this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];
                    //
                    this.set_upgrade_plans = true;
                    this.loading = false;
                    
                })
            }
        },

        getSellpointMarket(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data;
                    //document.title = this.sellpoint.business_name;
                    
                    //get market details
                    this.getMarketMainProductsAsSubscriptions();
                     

                    this.loading = false;

                }
            }).catch((err) => {
                //log it
                //location.replace("/");
              //console.log(err);
              this.loading = true;
            })
        },

        getMarketMainProductsAsSubscriptions(){
            service.getBusinessProducts(this, this.market.business_id).then(response => {
                if(response.body.status == 200) {
                    this.subscriptions = response.body.data;
                    this.plan1 = this.subscriptions[2];
                    this.plan2 = this.subscriptions[1];
                    this.plan3 = this.subscriptions[0];
                }
                //set up route if available
                if(this.$route.query.purchase){
                    this.setPurchase();
                }
                
            }).catch((err) => {})
                
        },

        purchase_plan_2(plan,plan_product_service_item_index){
            this.loading = true;
            this.$router.push('/purchase/?purchase='+plan.product_url_name+'&item='+plan_product_service_item_index);
            this.setPurchase();
            //srolls to the very top
            var top = document.getElementById("topwrap").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
            window.scrollTo(0, top); 
        },

        purchase_plan(plan){
            this.loading = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0]; //assign ist in array
        },

        upgrade_plan(plan){
            this.loading = true;
            this.set_upgrade_plan_process = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0]; //assign ist in array
            this.loading = false;
        },

        resetOptions(){
            this.selected_plan = {};
            this.selected_plan_product_service_item = {},
            this.total_price = 0;
            this.place_order = false;
        },

        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },

        validateUserName(){
            service.validateBusinessUserName(this, this.business).then(response => {
                if(response.body.status != 200) {
                    this.validate_user_name_error = true;
                    this.validate_user_name_message = "This username already exist";
                    this.deactivate_processing();
                }
            }).catch((err) => {
                //log it
                this.validate_user_name_error = true;
                this.validate_user_name_message = "This username already exist";
                this.deactivate_processing();
            })
        },

        getBusinessCategories() {
            service.getCategories(this).then(function(data) {
                this.categories = data.body.data;
                //seperate products and services categories
                this.categories.forEach(function(element) {
                    if(element.category_type == 1){
                        this.business_product_categories.push(element);
                    }
                    if(element.category_type == 2){
                        this.business_service_categories.push(element);
                    }
                }, this);
            })
        },

        proceedUpgradePlan(){
            //loop through plan to get matching price
            let found = false
            this.selected_plan.product_items_upgrade_details.forEach(function(element) {
                if(this.selected_plan_product_service_item.product_item_id == element.subscription_new_product_item_id){
                    this.selected_plan_product_service_item.product_item_price = element.subscription_new_product_total_amount_to_pay;
                    found = true
                }
             }, this);

             if(found){
                //prepare payment details

                //process pay
                this.selected_business = this.plan_business;
                this.setProcessPayment();
                //this.processPayment();
             }
        },

        setUpWithAccount(){
            this.resetMessages();
            this.activate_processing();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_purchase_plan: this.selected_plan_product_service_item.product_item_id,
                //user_business: this.user.user_business
            }
            this.checkUserDetailsForPurchase(payload,1);
        },

        checkUserDetailsForPurchase(payload,shouldLogin){
            //add order extras
            payload.order_referral_code = this.referral_code;
            payload.order_coupon = this.order_coupon;
            //../add order xtras
            service.checkUserDetails(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    //log in user
                    if(shouldLogin == 1){
                        this.data_boarding_message = "Account verified...";
                        this.loginUser();
                    }
                    //
                    if(data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, no business exist on this account";
                        this.deactivate_processing();
                    }else{
                        //get the verified businesses for purchase
                        this.user_businesses = data.body.data.user_businesses;
                        if(Object.keys(this.user_businesses).length == 1){
                            this.selected_business = this.user_businesses[0];
                        }
                        //auth/verify price to pay after calc of plans
                        //if(this.order_amount_to_pay != data.body.data_subscription_new_product_total_amount_to_pay){
                            this.order_amount = data.body.data_subscription_new_product_total_amount_to_pay;
                            this.order_amount_to_pay = this.order_amount; //rr
                        //}

                        //
                        this.selected_plan = data.body.data_subscription_selected_plan_details;
                        
                        //all good proceed
                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;
                        //
                        this.deactivate_processing();

                    }
                }else{
                    this.data_error_message = "Sorry, Account does not exist";
                    this.deactivate_processing();
                }
            }).catch((err) => {})
        },

        setProcessPurchase(){
            if(this.selected_plan.product_items_upgrade_details && (Object.keys(this.selected_plan.product_items_upgrade_details).length > 0))
            for(let details of this.selected_plan.product_items_upgrade_details){
                if(this.selected_plan_product_service_item.product_item_id == details.subscription_new_product_item_id){
                    this.selected_plan_product_service_item.product_item_price = details.subscription_new_product_total_amount_to_pay;
                    this.order_amount = this.selected_plan_product_service_item.product_item_price;
                    this.order_amount_to_pay = this.order_amount;
                }
            }
        },

        setUpNewAccount(){
            //create account by registering user
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address:  '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            }


            let navi = this.$router;

            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            
            //
            let phone_test = false;
            let email_test = false;
            if((this.payment_payer_phone != '') || (this.payment_payer_email != '')){
                if(this.payment_payer_phone != ''){
                    phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
                }else{
                    phone_test = true;
                }
                //
                if(this.payment_payer_email != ''){
                    email_test = re.test(String(this.payment_payer_email).toLowerCase());
                }else{
                    email_test = true;
                }
            }
            //

            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                if(credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null &&
                credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                        // toastr.success("Registration Successful", 'Success!');
                        this.data_boarding_message ="Registration Successful...";
                            //log user in
                            this.user.user_email = data.body.data.user_email;
                            this.user.user_password = data.body.data.user_password;
                            this.loginUser();
                            //
                            this.prepSetUpNewBusiness();
                            
                        }else if(data.body.status == 409) {
                            //toastr.warning("This User is already registered", 'Warning!');
                            this.data_error_message = "This User is already registered..";
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields...";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            }
        },

        setProcessPayment(){
            let can_process = true;
            //this.order_amount = this.selected_plan_product_service_item.product_item_price;
            this.order_details = "eShop Subscription Order:  - " + this.selected_plan.product_name+"(₦"+this.order_amount+")";
            if(this.set_up_with_existing_account){
                if(Object.keys(this.user_businesses).length == 0){
                    can_process = false;
                }else{
                    this.data_error_message = "No business selected !";
                    this.deactivate_processing();
                }
            }

            //all set //continue
            if(can_process){
                if(this.selected_plan_product_service_item.product_item_price == 0){ //free account
                    this.updatePayment("ref-free-account")
                }else{
                    //make order
                    var payload = {
                        order_user: this.user.user_id,//this.user.user_email,
                        order_referral_code: this.referral_code,
                        order_product: this.selected_plan.product_id,
                        order_product_item: this.selected_plan_product_service_item.product_item_id,
                        order_amount: this.order_amount,
                        order_details: this.order_details,
                        order_coupon:this.order_coupon,
                    }
                    service.makeAppSubscriptionOrder(this, payload).then(function(data) {
                        if(data.body.status == 201) {
                            //get ref
                            this.payment_ref = data.body.data.data_payref;
                            //get amount to pay
                            this.order_amount_to_pay = data.body.data.data_order_amount_to_pay;
                            //set as upgrade payment
                            //this.setAsUpgradePlan();
                            //proceed to pay
                            this.processPayment();
                        }
                    }).catch((err) => {})
                }
            }
        },

        //connect to a payment gateway
        processPayment() {
            //some onboarding
            this.data_boarding_message = "Preparing Payment Information";
            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var re_phone = /^\d{4}\d{3}\d{4}$/;

            //
            let phone_test = false;
            let email_test = false;
            // if((this.payment_payer_phone != '') && (this.payment_payer_email != '')){
                if(this.payment_payer_phone != ''){
                    phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
                }else{
                    phone_test = true;
                }
                //
                if(this.payment_payer_email != ''){
                    email_test = re.test(String(this.payment_payer_email).toLowerCase());
                }else{
                    //email_test = true;
                    //prompt to enter email
                    this.data_error_message = "Please enter your email address to make payment";
                }
           // }
            //
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                 //process online payment
                    this.payment_service = this.order_details;
                    let obj = this;
                    //this.amount_paid = data.plan_amount;
                    var handler = PaystackPop.setup({
                    // key: 'pk_live_64fe633bf8a53b0346ef8a44f54dc41cc0aa9f8b',
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,
                    // email: data.plan_user_email || "admin@sellpoints.ng",
                    email: this.payment_payer_email,
                    //amount:  (Math.round(this.selected_plan_product_service_item.product_item_price * 100)),//(data.plan_amount * 100), //in kobo
                    amount:  (Math.round(this.order_amount_to_pay * 100)),//(data.plan_amount * 100), //in kobo
                    ref: this.payment_ref, //"GWLOG"+(new Date().getTime()),
                    metadata: {
                        custom_fields: [
                            {
                                display_name: "eShop Subscription Order",
                                variable_name: "",
                                value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                            },
                            {
                                display_name: "Service",
                                variable_name: "service_type",
                                value: this.selected_plan.product_name
                            }
                            
                        ]
                    },
                    
                    callback: function(response){
                        obj.updatePayment(response.trxref); 
                    },
                    onClose: function(){
                        alert('window closed');
                    }
                    });
                    handler.openIframe();
                }

        },

        // update payments
        updatePayment(payment_ref) {

            //notify/verify txn server //paystack
            //log transctions
            //.......................................

            //then proceed
            let navi = this.$router;

            
            this.payment_successful = true;
            if(this.selected_plan_product_service_item.product_item_price != 0){ //not free account
                this.payment_successful_message = "Payment Successful...";
            }   


            this.upgradePlan(payment_ref);
        },

        setUpNewAccountBusiness(){
            this.resetMessages();
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 1, //shop
                business_subscription: service.market_app_default_plan, //this.selected_plan_product_service_item.product_item_id
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
              //  toastr.error('This Username already exists', 'Warning!');
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            //assign business 
                            this.getAppUserAndBusinessesDetails();
                           // this.user_businesses = data.body.data.data_user_businesses;
                            
                            //this.selected_business = data.body.data;
                            this.data_boarding_message = "Sellpoint Creation Successful.";
                            //navi.push('/'+this.business.business_user_name);
                            this.newBusinessForm = false; //close form
                        }else{
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        if(err) {
                            // toastr.warning("Something went wrong", 'Warning!'); 
                            this.data_error_message = "Something went wrong";
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    })
                }else {
                    // toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            }
        },
 
        prepSetUpNewBusiness(){
            let self = this;
            setTimeout(function(){ 
                self.set_up_business = true; 
                    self.data_boarding_message = " "; //reset
                    self.setComponent('show-new-business-form','');
                    self.deactivate_processing();
                    //srolls to the very top
                    var top = document.getElementById("banner").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
                    window.scrollTo(0, top); 
            }, 3000); //wait for 3sec and c
        },
        
        setAsUpgradePlan(){
            if(this.selected_business.business_id > 0){
                let navi = this.$router; 
                var payload = {
                    subscriber_module: 3, //business
                    subscriber_module_id: this.selected_business.business_id,
                    subscription_module: 3, //business
                    subscription_module_id: 'APP',
                    subscription_selected_plan: this.selected_plan.product_id,
                    //order xtras
                    order_referral_code: this.referral_code,
                    order_coupon:this.order_coupon,
                }
                service.setAppSubscriptionUpgradeDetails(this, payload).then(function(data) {
                    this.upgradable_plans = data.body.data;
                    this.upgrade_subscription = data.body.data_subscription;
                    this.current_subscription_product_service_item = data.body.data_subscription_current_subscription;
                    this.upgrade_business = this.selected_business.business_username;
                    this.selected_plan = data.body.data_subscription_selected_plan_details;
                    //set payment details
                    this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                    this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                    this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];
                    //
                    //set payment checkout
                    this.set_checkout = true;
                })
            }
        },

        upgradePlan(payment_ref){
            this.activate_processing();
            var credentials = {
                business_upgrade_subscription : this.upgrade_subscription,
                business_user_name: this.upgrade_business,
                business_group: service.market_app_name,
                business_group_token: service.apiToken,
                business_subscription: this.selected_plan_product_service_item.product_item_id,
                business_subscription_amount_paid: this.selected_plan_product_service_item.product_item_price,
                business_subscription_payment_ref: payment_ref,
                business_subscription_plan_upgrade_details: this.selected_plan.product_items_upgrade_details,
                business_current_subscription: this.current_subscription_product_service_item
            }
            
            let navi = this.$router; 
            service.upgradeBusinessMarketSubscription(this, credentials).then(function(data) {
                if(data.body.status ==  200) {
                    this.updateAppSubscriptionOrder();
                    //move to the business
                    //navi.push('/'+this.upgrade_business);
                   // location.replace("/"+this.upgrade_business);
                }
            }).catch((err) => {
                if(err) {
                    this.data_error_message = "Something went wrong";
                    this.deactivate_processing();
                }
            });
        },

        updateAppSubscriptionOrder(){
            var payload = {
                subscriber_module: 3,
                subscriber_module_id: this.selected_business.business_id,
                order_status: 15,
                order_payment_ref: this.payment_ref,
            }
            let navi = this.$router; 
            service.updateAppSubscriptionOrder(this, payload).then(response => {
                if(response.body.status == 200) {
                    navi.push('/'+this.selected_business.business_username);
                }
            }).catch((err) => {
                if(err.status == 404) {
                    toastr.warning("invalid login credentials", 'Warning!'); 
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            })
        },

        loginUser(){
            var credentials = {
                user_email: this.user.user_email,
                user_password: this.user.user_password
            }
            service.loginUser(this, credentials).then(response => {
                if(response.body.status == 200) {
                    let data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name); 
                    //localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                    //localStorage.setItem("sp_token_key", data.user_token_key); 
                    
                    //sessionstore
                    var user_data = {
                        "user_name": data.user_name,
                        "sp_token": data.user_session_key,
                        "sp_token_key": data.user_token_key
                    }
                    var credentials = {
                        session_key: data.user_session_key
                    } 
                    //revalidate  here till next version update
                    service.sessionGuard(this, credentials).then(response => {
                        if(response.body.status == 200) {
                            let data = response.body.data;
                            data.forEach(function(element) {
                                user_data.user_id = element.user_id;
                            }, this);
                            let self = this;
                            localforage.setItem(service.udb_name, user_data).then(function (value) {
                                self.preset();
                            }).catch(function(err) {});
                        }else {}
                        this.loading = false;
                    }).catch((err) => {})
                    //re-auth
                    // this.preset();
                  
                   // navi.push('/'+this.user.user_business);
                }
            }).catch((err) => {
                if(err.status == 404) {
                    toastr.warning("invalid login credentials", 'Warning!'); 
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            })
        },
        
    },

    mounted(){
        //always jump to top of page hack
        var top = document.getElementById("topwrap").offsetTop;
        window.scrollTo(0, top); 
        //continue
    },

    created: function(){
        //check for ref code
        //check local storage for refs
        let refcode = localStorage.getItem('refcode');
        if((refcode != undefined) && (refcode != '')){
            this.referral_code = refcode;
        }else if(this.$route.params.ref && (this.$route.params.ref != '')){
            //console.log('reffy'+this.$route.params.ref);
            this.referral_code = this.$route.params.ref;
            localStorage.setItem('refcode',this.referral_code);
        }
        //..//check for ref code

        //check store
        let user_store = this.$store.getters['account/getUser'];
        let business_store = this.$store.getters['account/getUserBusiness'];
        if((user_store.user_id && (user_store.user_id > 0)) && (business_store.business_id && (business_store.business_id > 0))){
            this.plan_user = user_store;
            this.plan_business = business_store;
        }
        //this.plan_business = this.$store.state.account.sellpoints.sellpoint; //this.$store.getters['account/getUserBusiness'];
        if(this.$route.query.upgrade){
            this.set_upgrade_plans = true; //mus not show purchase section
        }
        this.preset();
        this.getSellpointMarket();
        this.getBusinessCategories();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Purchase/script.js